<template>
  <div class="app-container">
    <div style="font-size: 30px; text-align: center">中转仓使用流程</div>
    <div style="margin-top: 10px">
      第一步：在中转仓网站注册账号，充值余额，<span style="color: red"
        >确保不低于100元押金，</span
      >防止到仓后续重扣除后，余额不足无法发货（不用后可以联系客服申请提现）。
    </div>
    <div style="border: #dcdfe6 solid 1px; margin: 15px 0" v-show="isCnyc">
      <img :src="cnyc_czjt_img" class="czjt_img_cs" />
    </div>
    <div style="border: #dcdfe6 solid 1px; margin: 15px 0" v-show="isRyyc">
      <img :src="ry_czjt_img" class="czjt_img_cs" />
    </div>
    <div>
      第二步：在网页首页下载中转仓拍单软件，并关联识别码<br />
      <span style="color: red; font-size: 15px"
        >云仓余额使用说明：拍单软件员工子账号，支持绑定不同的云仓账号。
        （1）客户端子账号识别码，未关联云仓账号.默认使用主账号关联云仓的账户余额。
        （2）客户端子账号识别码，关联新云仓账号后，使用子账号关联云仓账户余额</span
      >
    </div>
    <br /><br /><br /><br />

    <div style="font-size: 24px; text-align: center">中转仓发货规则</div>
    <div style="font-size: 15px">
      1.中转仓支持采购：拼多多，淘宝平台采购<br />
      2.中转仓默认匹配发货地最近中转仓。<br />
      3.上家发货后并且揽收后，立即生成电子面单快递单号发货。<br />
      4.为保证发货时效，<span style="color: red; font-size: 15px"
        >（软件设置可打开强制出单功能，避免发货超时）</span
      >
      中转仓24小时内自动生成3-7道揽收物流轨迹记录。韵达二代仓（随机始发地）7道以上揽收物流轨迹。注意：因平台政策原因，提前揽收功能中转仓不承担任何损失
    </div>
    <br /><br /><br /><br />

    <div style="font-size: 24px; text-align: center">中转仓扣费说明</div>
    <div style="font-size: 15px">
      （1）下单成功后按0.5KG扣除首重费用（快递费+操作费）。<br />
      （2）到达中转仓称重发出后计算实际重量，扣除续重费用+拆包费（不勾选拆包不扣费）。<br />
      （3）下单成功后，中转仓未取号发货。可取消下单退还中转仓首重费用。
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "jianjie",
  data() {
    return {
      activeIndex: 0,
      idx: 2,
      isShow: false,
      nbisShow: false,
      userName: "",
      user_balance: 0.0,
      userType: "",

      userToken: Cookies.get("view_userToken"),
      isLogin: true,
      cnyc_czjt_img: require("@/assets/cnyc_czjt.png"),
      ry_czjt_img: require("@/assets/ry_czjt.jpg"),
      isCnyc: true,
      isRyyc: false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");
    // if (userToken == undefined) {
    //     this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
    const sn = Cookies.get("view_site_name");
    if (sn == "菜鸟云仓" || sn == "菜鸟云仓test") {
      this.isCnyc = true;
      this.isRyyc = false;
    } else if (sn == "如意云仓") {
      this.isRyyc = true;
      this.isCnyc = false;
    }
  },
  methods: {},
};
</script>

<style scoped>
.app-container {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/zzc/jianjie.vue